import * as React from "react";

export type ShortLinkDto = {
    id: number;
    shortLink: string,
    targetLink: string,
    hashCode: string
}

export const defaultShortLinkDto:ShortLinkDto = {
    id: 0,
    shortLink: "",
    targetLink: "",
    hashCode: ""
}

export type CreateShortLink = {
    url: string;
}

export type NavbarModalItem = {
    name: string;
    description: string;
    href: string;
    icon: React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & { title?: string, titleId?: string } & React.RefAttributes<SVGSVGElement>>;
}

export type NavbarModalProps = {
    items: NavbarModalItem[];
    callsToActions: NavbarModalItem[];
}

export type BlocklistItem = {
    domain: string,
    createdAt: string
}